<template>
	<el-popover
		v-if="scope.row[tableData.bind]"
		placement="top-start"
		trigger="hover"
		:content="scope.row[tableData.bind] || '-'"
	>
		<el-button class="over-hidden" slot="reference" type="text" @click="jump">{{
			scope.row[tableData.bind]
		}}</el-button>
	</el-popover>
	<span v-else>-</span>
</template>

<script>
export default {
	name: 'jumpLink',
	props: {
		tableData: Object,
		scope: Object,
	},
	methods: {
		jump() {
			let bindValue = this.scope.row[this.tableData.bind];
			if (!bindValue) return;
			if (!bindValue.startsWith('https') && !bindValue.startsWith('http')) {
				bindValue = '//' + bindValue;
			}
			window.open(bindValue);
		},
	},
};
</script>

<style scoped>
.over-hidden {
  text-overflow: ellipsis;
  width: 100%;
  overflow: hidden;
  text-align: left;
}
</style>
